import { FormControl, FormControlLabel, Switch } from '@mui/material'
import { t } from 'i18next'


const FromCityeyeFilter = ({ filters = {}, onChange = () => { } }) => {
  const handleChange = (_, value) => {
    onChange({
      ...filters,
      fromCityeye: value ? value : undefined
    })
  }

  return (
    <>
      <FormControl fullWidth>
        <FormControlLabel
          control={
            <Switch
              id='gateway-filter-from-cityeye'
              checked={filters.fromCityeye}
              value={filters.fromCityeye}
              onChange={handleChange}
            />
          }
          label={t('filters.gateways.fromCityeye.label')}
          labelPlacement="end"
        />
      </FormControl>
    </>
  )
}

export default FromCityeyeFilter
